// Relational character "scenarios" for the Command Center helper — display meta
// mirrored from the backend PERSONAS (backend owns the AI tone). The figure +
// label replace the old "Cmdr Bot" so it feels like a real relational being.
// The name already carries any royal title (e.g. "King Isaiah", "Queen Vanessa"),
// so greetings never prepend King/Queen themselves.
export const PERSONAS = [
  { key: "king_herald", label: "Royal Herald", figure: "👑",
    greetings: ["Greetings, {name}! What shall we do today?", "Welcome back, {name}! What's the plan?", "{name}! Wonderful to see you — what now?"] },
  { key: "homie", label: "Your Homie", figure: "🧢",
    greetings: ["Yo, what's good {name}? What we gettin' into?", "Ayy {name}! What's the move today?"] },
  { key: "bestie", label: "Best Friend", figure: "😎",
    greetings: ["Hey {name}! What do you wanna do today, buddy?", "Yo {name}! Let's have some fun — what's up?"] },
  { key: "coach", label: "Coach", figure: "🏅",
    greetings: ["Let's GO, champ {name}! What are we crushing today?", "Alright {name}, game time! What's the play?"] },
  { key: "parent", label: "Mom or Dad", figure: "❤️",
    greetings: ["Hey little buddy {name}, whatcha need?", "Hey champ {name}! What's the plan?", "Hey kiddo {name}, what can I do for you?", "Hey my love {name}, what would you like?", "Hey superstar {name}!"] },
  { key: "country", label: "Country Pal", figure: "🤠",
    greetings: ["Howdy partner {name}! What can I rustle up for ya?", "Well howdy {name}! What're we up to?"] },
  { key: "mountain", label: "Mountain Buddy", figure: "🏕️",
    greetings: ["Whoa there {name}, dude! What're we fixin' to do?", "Sweet, {name}! What's the adventure today?"] },
  { key: "hype_mc", label: "Hype MC", figure: "🎤",
    greetings: ["AYYY! Make some noise for {name}! What's the move?", "The one and only {name} is here! What's poppin'?"] },
];

export const PERSONA_BY_KEY = Object.fromEntries(PERSONAS.map((p) => [p.key, p]));
export const DEFAULT_PERSONA = "king_herald";

// Signature reaction lines shouted when a power fires.
export const CATCHPHRASES = {
  king_herald: ["By royal decree!", "It is done, my liege!", "Long may you reign!"],
  homie: ["Ayy, let's GO!", "That's fire, no cap!", "We up!"],
  bestie: ["So cool!", "Yesss, let's do it!", "That's awesome, buddy!"],
  coach: ["THAT'S how we win!", "Boom! Great play!", "You're on fire, champ!"],
  parent: ["That's my superstar!", "Look at you go!", "So proud of you!"],
  country: ["Yeehaw!", "Well ain't that somethin'!", "Giddy up!"],
  mountain: ["Whoa, gnarly!", "Sweet, dude!", "Totally rad!"],
  hype_mc: ["AYYYY!", "MAKE SOME NOISE!", "Turn it UP!"],
};

export function personaCatchphrase(key) {
  const list = CATCHPHRASES[key] || CATCHPHRASES[DEFAULT_PERSONA];
  return list[Math.floor(Math.random() * list.length)];
}

export function personaMeta(key) {
  return PERSONA_BY_KEY[key] || PERSONA_BY_KEY[DEFAULT_PERSONA];
}
export function personaGreeting(key, name) {
  const list = personaMeta(key).greetings || ["Hey {name}! What would you like to do?"];
  const pick = list[Math.floor(Math.random() * list.length)];
  return pick.replace("{name}", name || "friend");
}
